/** Sett AbilitySpec seed kit (wiki-aligned numeric batch 2). */
export const SETT_ABILITY_DEFS = [
  {
    id: 'sett_q',
    champKey: 'sett',
    slot: 'Q',
    name: 'Knuckle Down',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 9,
    manaCost: 0,
    vfxId: 'sett_q',
    status: 'wired'
  },
  {
    id: 'sett_w',
    champKey: 'sett',
    slot: 'W',
    name: 'Haymaker',
    targeting: 'skillshot_cone',
    range: 720,
    castTime: 0.75,
    travelSpeed: null,
    width: null,
    radius: 720,
    cooldown: 18,
    manaCost: 0,
    vfxId: 'sett_w',
    coneAngleRad: 1.4,
    status: 'wired'
  },
  {
    id: 'sett_e',
    champKey: 'sett',
    slot: 'E',
    name: 'Facebreaker',
    targeting: 'aoe_self',
    range: 450,
    castTime: 0.15,
    travelSpeed: null,
    width: null,
    radius: 450,
    cooldown: 16,
    manaCost: 0,
    vfxId: 'sett_e',
    status: 'wired'
  },
  {
    id: 'sett_r',
    champKey: 'sett',
    slot: 'R',
    name: 'The Show Stopper',
    targeting: 'targeted',
    range: 400,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 120,
    manaCost: 0,
    vfxId: 'sett_r',
    status: 'wired'
  }
];
